import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Utils } from '../../../Utils';
import { Helpers } from '../../../Helpers';
import Loader from '../../Loader';

function KpiStandard({ data = {}, isStatic = false, isInitial = false, initialTextColor = "" }) {
  console.log("KpiStandard data:", data);
  console.log("isInitial:", isInitial);
  console.log("initialTextColor:", initialTextColor);
  const currentOrg = useSelector((state) => state?.org);
  const { subModuleData, isDashboardLoading } = useSelector((state) => state?.dashboardComponents);

  const [countData, setCountData] = useState(0);
  const [previousCountData, setPreviousCountData] = useState(300);
  const [percentageChange, setPercentageChange] = useState(-13.11);
  const [periodLabel, setPeriodLabel] = useState('Revenue This Month');
  const [previousPeriodLabel, setPreviousPeriodLabel] = useState('Previous Month');
  let count = 800;
  let textColor = data?.textColor ? data?.textColor : (isInitial && initialTextColor) ? initialTextColor : "#000000";

  useEffect(() => {
    Utils.calculateKpiData(subModuleData, data, Utils, setCountData, setPreviousCountData, setPercentageChange, setPeriodLabel, setPreviousPeriodLabel);
  }, [subModuleData?.[data?.moduleId], data]);

  return (
    <>
      {isDashboardLoading && !countData ? (
        <div className='chart-loader'><Loader type={'infinitySpin'} isVisible={true} /></div>
      ) : (
        <div style={{ maxWidth: '300px', margin: '0 auto', padding: '1px', border: '0px solid #ccc', borderRadius: '8px' }}>
          {countData > 0 || isStatic ? (
            <>
              <h6 className="card-title" style={{ color: textColor, fontSize: '14px', marginBottom: '1px' }}>{isStatic ? (<span>{periodLabel}</span>) : (<span>{data?.field} {Utils.periodLabelMapping[periodLabel]}</span>)}</h6>
              <h2 className="fw-bold" style={{ color: textColor, fontSize: '14px', marginBottom: '1px' }}>
                {isStatic ? (
                  <span>
                    {Utils.checkCurrency(count, data, currentOrg, isStatic)}
                  </span>
                ) : (
                  <span>
                    {Utils.checkCurrency(countData, data, currentOrg, isStatic)}
                  </span>
                )}

                {percentageChange !== null && (
                  <span
                    // className={`text-${percentageChange >= 0 ? 'success' : 'danger'}`}
                    style={{ color: textColor, fontSize: '16px', marginLeft: '5px' }}>
                    {percentageChange >= 0 ? '▲' : '▼'}{" "} {Math.abs(percentageChange).toFixed(2)}%
                  </span>
                )}
              </h2>
              <p style={{ color: textColor, fontSize: '12px', marginBottom: '1px' }}>{isStatic ? (<span>{previousPeriodLabel}</span>) : (<span>{Utils.periodLabelMapping[previousPeriodLabel]} :{" "} {Utils.checkCurrency(previousCountData, data, currentOrg, isStatic)}</span>)}</p>
            </>
          ) : (
            <div className="h-100 align-self-center align-center py-3" style={{ color: textColor }}>
              No Data Found
            </div>
          )}
        </div>
      )}
      {isStatic && <small className="text-muted-" style={{ color: textColor, '--bs-text-opacity': 1 }}>Standard</small>}
    </>
  );





}

export default KpiStandard;
